<template>
  <svg
  :width="width"
  :height="height"
   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 9V14"
      stroke="var(--color-warning)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
    />
    <path
      d="M12.0001 21.4093H5.94005C2.47005 21.4093 1.02005 18.9293 2.70005 15.8993L5.82006
       10.2793L8.76006 4.9993C10.5401 1.7893 13.4601 1.7893 15.2401 4.9993L18.1801
        10.2893L21.3001 15.9093C22.9801 18.9393 21.5201 21.4193 18.0601 21.4193H12.0001V21.4093Z"
      stroke="var(--color-warning)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
    />
    <path
      d="M11.9945 17H12.0035"
      stroke="var(--color-warning)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
  },
  data() {
    return {
      isHover: false,
    };
  },
  props: {
    color: {
      type: String,
    },
    width: {
      type: String,
      default: '24',
    },
    height: {
      type: String,
      default: '24',
    },
  },
};
</script>
